import { ComposedConditionSet } from '../condition/condition.interface';
import { SubmissionInfo } from '../custom/element-submission.interface';
import { SurveyVariables } from '../custom/survey-variables.interface';

export interface Element {
  // id: string;
  id: number;

  name: string;
  type: QuestionType;
  element_type: ElementType;
  page_id: number;
  hidden?: boolean;
  rank: number;
  question_text: string;
  is_skippable?: boolean;
  required: boolean;
}

export enum ElementType {
  QUESTION_ELEMENT = 'questionElement',
  LOGIC_ELEMENT = 'logicElement',
}

export enum QuestionType {
  // 1. Choice Types
  SINGLE_CHOICE = 'single-choice',
  MULTIPLE_CHOICE = 'multiple-choice',
  DROP_DOWN_SINGLE_CHOICE = 'drop-down-single-choice',
  DROP_DOWN_MULTIPLE_CHOICE = 'drop-down-multiple-choice',
  // 2. Text Types
  OPEN_ENDED = 'open-ended',
  NUMERIC = 'numeric',
  // SHORT_TEXT_INPUT = 'short-text-input',
  // LONG_TEXT_INPUT = 'long-text-input',
  // 3. Static Content
  // TEXT_DISPLAY = 'text-display',
  DISPLAY = 'display',
  LOCATION = 'location',

  // 4. Media Upload Types
  IMAGE = 'image',
  VIDEO = 'video',
  VOICE = 'voice',
  // MULTI_FORMAT = 'multi-format',
  FILE = 'file',

  // 5. Matrix Question Types
  SINGLE_GRID = 'single-grid',
  MULTIPLE_GRID = 'multiple-grid',
  // // 6. Ordering
  // DRAG_DROP = 'drag-drop',
  CLICK_TO_RANK = 'click-to-rank',
  // CONSTANT_SUM = 'constant-sum',
  // BUCKET_RANK = 'bucket-rank',

  // 7. Interactive Types
  // SWIPE_IMAGE = 'swipe-image',
  // SWIPE_TEXT = 'swipe-text',
  // IMAGE_ANNOTATION = 'image-annotation',
  // SHELF = 'shelf',

  // 8. Flow Control Types
  // TERMINATE = 'terminate',
  // QUOTA = 'quota',

  // 9. Build your own (Free Format)
  // FREE_FORMAT = 'free-format',

  // 10.Date/Time Types
  // DATE = 'date',
  // TIME = 'time',
  // DATE_AND_TIME = 'date-and-time',

  // 11.User Data
  // EMAIL = 'email',
  // PHONE_NUMBER = 'phone-number',
  // SIGNATURE = 'signature',

  // Not Completed
  // TEXT_HIGHLIGHTER = 'text-highlighter',
  // SEMANTIC_DIFFERENTIAL = 'semantic-differential',
  // MAX_DIFF = 'max-diff',
  // FLOW = 'flow',
  HIDDEN = 'hidden',
  // CONVERSATION = 'conversation',
  SKIP_LOGIC = 'skip-logic',
}

export interface BaseElementSettings {
  id: string;
}

export interface BaseComposedElement {
  // id: string;
  id: number | string;

  name: string;
  element_type: ElementType;
  page_id: number | string;
  rank: number;
  questionText: string;
  hidden?: boolean;
  required: boolean;

  type: QuestionType;

  //   Added
  answerObject: { [k: string]: string | number | boolean | undefined | object };
  questionMeta: SurveyVariables;

  submissionInfo: SubmissionInfo;

  conditional_display_manifest?: ComposedConditionSet;
}
